import classNames from 'classnames';

import tagBadge from './assets/tag-badge.svg';
import classes from './ExtraOfferRewardComponent.module.scss';

type ExtraOfferRewardComponentProps = {
  rewardImageUrl?: string;
  extraPercentage?: number;
  fontSize?: number;
  className?: string;
};

const ExtraOfferRewardComponent = ({ extraPercentage, className }: ExtraOfferRewardComponentProps) => (
  <svg aria-hidden className={classNames(classes.extraOfferReward, className)} viewBox="0 0 113 92">
    <defs>
      <radialGradient cx="50%" cy="50%" id="extraGlow" r="50%">
        <stop offset="0%" stopColor="#c484ff" stopOpacity="1" />
        <stop offset="100%" stopColor="#c484ff" stopOpacity="0" />
      </radialGradient>
      <filter height="160%" id="extraTextShadow" width="160%" x="-30%" y="-30%">
        <feDropShadow dx="0" dy="1.592" floodColor="#20003f" floodOpacity="1" stdDeviation="0" />
      </filter>
    </defs>
    <ellipse cx="56.5" cy="46" fill="url(#extraGlow)" rx="46" ry="46" />
    <image height="54.8668" href={tagBadge} transform="rotate(-18.43 56.5 46)" width="84.11" x="14.445" y="18.567" />
    {extraPercentage != null && (
      <text
        className={classes.percentage}
        dominantBaseline="central"
        fill="#ffffff"
        filter="url(#extraTextShadow)"
        textAnchor="middle"
        x="56.5"
        y="46"
      >
        {`+${extraPercentage}%`}
      </text>
    )}
  </svg>
);

export default ExtraOfferRewardComponent;
